import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { observable, makeObservable } from 'mobx'
import i18n from 'i18next'
import { Droppable, Draggable } from 'react-beautiful-dnd'
import Button from '../UniformComponents/Button'

import '../assets/css/pagelist.css'
import SurveyPage from './SurveyPage'
import PageBlock from './PageBlock'
import { warningsAfterPageMove } from '../utils/SurveyChangeWarnings'
import WordExport from './WordExport'

@observer
class StandardPages extends Component {
    componentDidMount() {
        const { store } = this.props
        store.dropTargets.pageList = this
    }

    dropReorderNew = (from, to) => {
        const { store } = this.props
        const { survey } = store

        if (from === to) return

        store.pendingPageMove = survey.movePage(store, from, to, true)
        Object.assign(store.pendingPageMove, { from, to })

        const warnings = warningsAfterPageMove(survey, store)

        const {
            isSkipLogicAffected,
            isInheritanceAffected,
        } = warnings

        store.surveyUpdateWarnings = warnings
        store.showInheritanceWarning = (
            isSkipLogicAffected
            || isInheritanceAffected
        )

        if (!store.showInheritanceWarning) {
            survey.saveMove(store, store.pendingPageMove.body, store.pendingPageMove.endpoint)
        }
    }

    dropReorder = (from, to) => {
        process.env.USE_NEW_SURVEY_WARNINGS
            ? this.dropReorderNew(from, to)
            : this.dropReorderOld(from, to)
    }

    dropReorderOld = (from, to) => {
        const { store } = this.props
        const { survey } = store
        console.log('dropReorder pageList')
        if (from !== to) {
            const currentPage = survey.pages[from]
            const pageId = currentPage.id.toLowerCase()
            const currentPageQuestionIds = currentPage.questions.map((pq) => pq.id.toLowerCase())
            store.pendingPageMove = survey.movePage(store, from, to, true)
            Object.assign(store.pendingPageMove, { from, to })
            const parentIndexes = survey.pages[to].questions.reduce((indexes, pq) => {
                if (pq.parentId) {
                    const parentIndex = pq.getParentPageIndex(survey)
                    if (parentIndex >= (to + 1)) {
                        indexes.push(parentIndex)
                    }
                }
                return indexes
            }, [])
            let pageQuestionIds = []
            let childIndexes = []
            if (currentPage.questions.length) {
                pageQuestionIds = currentPage.questions.reduce((ids, pq) => {
                    ids.push(pq.id.toLowerCase())
                    return ids
                }, [])
                childIndexes = survey.pages.reduce((children, page) => {
                    if (page.questions && page.priority <= (to + 1) && page.questions.filter((pq) => (pq.parentId && pageQuestionIds.includes(pq.parentId.toLowerCase()))).length) {
                        children.push(page.priority)
                    }
                    return children
                }, [])
            }
            const {
                prevPageIds,
                nextPageIds,
                prevPageQuestionIds,
                nextPageQuestionIds,
            } = survey.pages.reduce((obj, page) => {
                if (page.priority < currentPage.priority) {
                    obj.prevPageIds.push(page.id)
                    obj.prevPageQuestionIds = obj.prevPageQuestionIds.concat(page.questions.map((pq) => pq.id.toLowerCase()))
                } else if (page.priority > currentPage.priority && page.pageType === 'ST') {
                    obj.nextPageIds.push(page.id)
                    obj.nextPageQuestionIds = obj.nextPageQuestionIds.concat(page.questions.map((pq) => pq.id.toLowerCase()))
                }
                return obj
            }, {
                prevPageIds: [],
                nextPageIds: [],
                prevPageQuestionIds: [],
                nextPageQuestionIds: [],
            })
            let skipToPage = false
            let showIf = false
            if (!parentIndexes.length && !childIndexes.length) {
                skipToPage = survey.skipLogic.some((logic) => {
                    let pageQuestionId = -1
                    if (logic.triggerGroups[0]
                        && logic.triggerGroups[0].children[0]
                        && logic.triggerGroups[0].children[0].triggers[0]) {
                        pageQuestionId = logic.triggerGroups[0].children[0].triggers[0].condition.pageQuestionId
                    }
                    return (
                        logic.action.kind === 'PageToPage'
                        && (
                            (logic.action.pageId === pageId && nextPageIds.includes(logic.trigger.condition.pageId))
                                || (logic.trigger.condition.pageId === pageId && prevPageIds.includes(logic.action.pageId))
                        )
                    )
                    || (
                        logic.action.kind === 'SkipToPage'
                        && (
                            (currentPageQuestionIds.includes(pageQuestionId)
                                && prevPageIds.includes(logic.action.pageId))
                            || (
                                pageId === logic.action.pageId
                                    && nextPageQuestionIds.includes(pageQuestionId)
                            )
                        )
                    )
                })
                if (!skipToPage && currentPage.questions.length) {
                    showIf = survey.skipLogic.some((logic) => (
                        logic.action.kind === 'ShowQuestion'
                            && (
                                (
                                    currentPageQuestionIds.includes(logic.action.pageQuestionId)
                                    && logic.triggerGroups.some((tg) => (
                                        tg.children.some((child) => (
                                            child.triggers.some((trigger) => (
                                                nextPageQuestionIds.includes(trigger.condition.pageQuestionId)
                                            ))
                                        ))
                                    ))
                                ) || (
                                    prevPageQuestionIds.includes(logic.action.pageQuestionId)
                                    && logic.triggerGroups.some((tg) => (
                                        tg.children.some((child) => (
                                            child.triggers.some((trigger) => (
                                                currentPageQuestionIds.includes(trigger.condition.pageQuestionId)
                                            ))
                                        ))
                                    ))
                                )
                            )
                    ))
                }
            }
            if (parentIndexes.length || childIndexes.length || skipToPage || showIf) {
                store.showInheritanceWarning = true
            } else {
                // survey.movePage(store, from, to)
                survey.saveMove(store, store.pendingPageMove.body, store.pendingPageMove.endpoint)
            }
        }
    }

    render() {
        const { store, pageDragId } = this.props
        const { survey } = store
        const { standardPages, pageBlocks } = survey

        const pageBlockPages = []
        pageBlocks.forEach((pb) => {
            pb.pages.forEach((p) => pageBlockPages.push(p))
        })
        console.log('standardPages')
        return (
            <div>
                {pageBlocks.map((b, i) => <PageBlock pageBlock={b} store={store} index={i} pageDragId={pageDragId} />)}
                <Droppable droppableId="pageList" type="pageList">
                    {(provided, snapshot) => (
                        <div
                            style={{ border: '0px solid red', minHeight: '29px' }}
                            ref={provided.innerRef}
                        >
                            {standardPages.map((page, index) => (
                                !pageBlockPages.includes(page.id) ? (
                                    <Draggable
                                        key={`draggable_${page.id}`}
                                        draggableId={`surveyPage_${page.id}`}
                                        isDragDisabled={survey.closed || page.isLocked}
                                        id={`draggable_${page.id}`}
                                        index={index - pageBlockPages.length}
                                    >
                                        {(provided, snapshot) => (
                                                <SurveyPage
                                                    provided={provided}
                                                    key={page.id}
                                                    store={store}
                                                    page_id={index}
                                                    page={page}
                                                    history={history}
                                                    pageDragId={pageDragId}
                                                    draggableId={`surveyPage_${page.id}`}
                                                />
                                            )
                                        }
                                    </Draggable>
                                ) : null
                            ))}
                            {provided.placeholder}
                        </div>
                    )}
                </Droppable>
            </div>
        )
    }
}

@observer
class ExitdPages extends Component {
    render() {
        const { store } = this.props
        const { survey } = store
        const { exitPages, pages } = survey
        console.log('ExitPages')
        return (
            exitPages.map((page, index) => (
                <SurveyPage
                    key={page.id}
                    store={store}
                    page_id={(pages.length + index)}
                    page={page}
                    history={history}
                    isFirstExitPage={index === 0}
                />
            ))
        )
    }
}

class PDFLoader extends Component {
    render() {
        return (
            <div style={{
                position: 'fixed',
                zIndex: 10000,
                left: '0px',
                top: '0px',
                right: '0px',
                bottom: '0px',
                backgroundColor: 'rgba(119, 119, 119, 0.7)',
            }}
            >
                <div style={{
                    position: 'fixed',
                    width: '300px',
                    top: '50%',
                    left: '50%',
                    marginLeft: '-150px',
                    martginTop: '-32px',
                    backgroundColor: '#fff',
                    textAlign: 'center',
                    boxShadow: '1px 1px 7px 1px rgba(128,128,128,0.3)',
                    borderRadius: '4px',
                    borderColor: '#DDD',
                    padding: '15px',
                }}
                >
                    Generating PDF
                    <div className="loader" />
                </div>
            </div>
        )
    }
}

@observer
class PageList extends Component {
    @observable loadingPDF

    constructor(props) {
        super(props)
        makeObservable(this)
        this.loadingPDF = false
        this.addPage = this.addPage.bind(this)
    }

    addPage() {
        const { store } = this.props
        const { survey } = store
        const pageBlockPages = survey.pageBlocks.flatMap((pb) => pb.pages.slice())
        const priority = pageBlockPages.length + 1
        if (survey.closed) {
            return
        }
        survey.addPage(store, priority)
    }

    addSurveyQuota = () => {
        const { store } = this.props
        const { survey } = store
        if (survey.closed) {
            return
        }
        store.quotaRouting = true
        store.showPageRouting = true
    }

    printSurvey = () => {
        const { store } = this.props
        const { survey } = store
        // store.gotoExternal(survey.getPrintLinkstore))
        window.open(`/survey/${survey.id}/print`, '_blank')
        // history.push(`/survey/${survey.id}/print`)
    }

    downloadPDF = () => {
        const { store } = this.props
        const { survey, surveyLocale } = store
        this.loadingPDF = true
        console.log(`${surveyLocale} ${survey.id}`)
        store.http.get(`/puppeteer/preview/${survey.id}/${surveyLocale}`)
            .then((blob) => {
                console.log(`done ${typeof blob}`)
                const a = document.createElement('a')
                a.href = window.URL.createObjectURL(blob)
                a.setAttribute('download', `${survey.id}.pdf`)
                a.click()
                this.loadingPDF = false
                store.addNotification(null, 'Download finished', 'success')
            })
            .catch((e) => {
                this.loadingPDF = false
                store.addNotification(null, 'Download failed', 'error')
            })
    }

    downloadWord = async () => {
        const { store } = this.props
        const { survey, surveyLocale } = store
        const wordExport = new WordExport(survey, survey.allQuestions, surveyLocale, store)
        await wordExport.requestWordDoc()
    }

    onSortEnd = ({ oldIndex, newIndex }) => {
        const { store } = this.props
        if (oldIndex !== newIndex) {
            store.survey.movePage(oldIndex, newIndex)
        }
    }

    addMandatoryQuestions = async () => {
        const { store } = this.props
        const { survey } = store
        const { questionLibrary } = survey
        const filtered = questionLibrary.filter(questionLibrary.questionLists.get('mandatory'))

        for (let i = 0; i < filtered.length; i += 1) {
            const question = filtered[i]

            if (!question.parentId) {
                await survey.pages[0].addQuestion({ question, survey, store })
            }
        }

        if (questionLibrary.questionLists.get('mandatory').length) {
            store.showMissingInheritedQuestionModal = true
            return
        }

        questionLibrary.mandatoryQuestionsAdded()
    }

    render() {
        const { store, history, pageDragId } = this.props
        const { survey } = store
        const { standardPages, exitPages, welcomePage } = survey
        return (
            <div className="pagelist">
                { this.loadingPDF
                    && <PDFLoader />}
                <div className="surveyDetaisls">
                    {survey.hasMandatoryQuestions && !survey.closed
                        && (
                            <div>
                                <Button
                                    cssClass="addmandatoryreact"
                                    onClick={this.addMandatoryQuestions}
                                >
                                    {i18n.t('s_add_mandquestions')}
                                    <i className="fal fa-plus" />
                                </Button>
                            </div>
                        )}
                </div>
                <SurveyPage
                    key={welcomePage.id}
                    store={store}
                    page_id={0}
                    page={welcomePage}
                    history={history}
                />

                <StandardPages store={store} pageDragId={pageDragId} />

                <ExitdPages store={store} />
            </div>
        )
    }
}

export default PageList
